import {useMemo} from "react";


export default function useArray<T>(a: ReadonlyArray<T>) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => a, a)
}
